import styled from 'styled-components'
import { Colors } from '@doordash/design-language'

export const FormattedDivider = styled.hr`
  color: ${Colors.SystemGrey0};
  opacity: 0.33;
`
